import React from 'react';
import i18next from 'i18next';
import moment from 'moment';

export enum DateFormat {
    DEFAULT = 'DEFAULT',
    US = 'US'
}

/**
 * Date formats per usage/library.
 */
interface DateFormats {
    display: string;
    moment: string;
    datePicker: string;
}

export const DATE_FORMATS: Record<DateFormat, DateFormats> = {
    [DateFormat.DEFAULT]: {
        display: 'DD.MM.YYYY',
        moment: 'DD.MM.YYYY',
        datePicker: 'dd.MM.yyyy'
    },
    [DateFormat.US]: {
        display: 'MM/DD/YYYY',
        moment: 'MM/DD/YYYY',
        datePicker: 'MM/dd/yyyy'
    }
};

export function getCurrentDateFormat(): DateFormats {
    return i18next.language.startsWith('en') ? DATE_FORMATS.US : DATE_FORMATS.DEFAULT;
}

/**
 * Formats the date to the format dependant on the currently set language.
 * Possible formats:
 * - `MM/DD/YYYY` for `en` language
 * - `DD.MM.YYYY` for other languages
 */
export function date(date: string): string {
    return moment(date).format(getCurrentDateFormat().display);
}

/**
 * Returns either `moment(date).fromNow()` result or empty string if the provided date is not lower than `now`.
 */
export function dateAgo(date: string): string {
    return moment(date) < moment() ? moment(date).fromNow() : '';
}

/**
 * Removes `\r` characters and splits input string by `\n`, putting texts (lines) in <span> with <br> at the end of text.
 */
export function nl2br(text: string): React.ReactNode[] {
    return text
        .replace(/\r/g, '')
        .split('\n')
        .map(wrapTextLine);
}

const wrapTextLine = (textLine: string, idx: number): React.ReactNode => (
    <span key={idx}>
        {textLine}
        <br />
    </span>
);
